import { Text, useDesignTokens } from "@gradience/ui";
import { displayFormErrors, useFormContext } from "../util";

export function FormErrors() {
  const form = useFormContext();
  const designTokens = useDesignTokens();
  return (
    <form.Subscribe selector={(state) => displayFormErrors(state)}>
      {(errorMessage) =>
        errorMessage ? (
          <Text
            textStyle="strong"
            style={{
              color: designTokens.colors.text.brand,
            }}
          >
            {errorMessage}
          </Text>
        ) : null
      }
    </form.Subscribe>
  );
}
